import { useLazyQuery } from '@apollo/client'
import {
  UploadProcessDocumentsDocument,
  UploadProcessDocumentsQuery,
  UploadProcessDocumentsQueryVariables,
} from 'generated/resources/graphql'

export type UploadProcessDocument =
  UploadProcessDocumentsQuery['documents']['uploadProcessDocumentsConnection']['nodes'][number]

export const useGetUploadProcessDocuments = () => {
  const [fetchUploadProcessDocuments, { loading }] = useLazyQuery(UploadProcessDocumentsDocument)

  const fetch = async (variables: UploadProcessDocumentsQueryVariables) => {
    const { data } = await fetchUploadProcessDocuments({ variables })

    return data?.documents.uploadProcessDocumentsConnection.nodes || []
  }

  return {
    fetch,
    loading,
  }
}
